export enum SearchDataEnum {
  DEFAULT = "",
  MATERIAL = "materials",
  LOCATION = "locations",
  USER = "users",
  CONTAINER = "containers"
}
